import * as React from "react";
import { Page, Card, Alert, Text } from "tabler-react";
import TradesSiteWrapper from "./TradesSiteWrapper.react";
import RefreshButton from "./RefreshButton.react";
import { getMarketSnapshot, fmtDateTime } from "./api";

class MarketPage extends React.Component {
  state = { loading: true, error: "", snapshot: null };

  componentDidMount() {
    this.load();
  }

  load = async () => {
    this.setState({ loading: true, error: "" });
    try {
      const snapshot = await getMarketSnapshot();
      this.setState({ snapshot, loading: false });
    } catch (e) {
      this.setState({ error: e.message || "Failed to load market snapshot", loading: false });
    }
  };

  formatExpiry(value) {
    if (!value) return "—";
    const parts = String(value).slice(0, 10).split("-");
    if (parts.length < 3) return String(value);
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const month = months[Number(parts[1]) - 1];
    return month ? `${Number(parts[2])} ${month} ${parts[0]}` : String(value);
  }

  price(value) {
    return value != null && value !== "" ? Number(value).toFixed(2) : "—";
  }

  leg(title, strike, symbol, ltp) {
    return (
      <div className="col-md-6 mb-3" key={title}>
        <div className="border rounded p-3 h-100">
          <div className="text-muted small mb-1">{title}</div>
          <div style={{ fontWeight: 650, fontSize: "1.35rem", lineHeight: 1.1 }}>
            {strike != null ? strike : "—"}
          </div>
          <div className="text-muted small">Strike</div>
          <div className="text-muted small" style={{ wordBreak: "break-all" }}>{symbol || ""}</div>
          <div className="mt-2">LTP {this.price(ltp)}</div>
        </div>
      </div>
    );
  }

  render() {
    const { loading, error, snapshot } = this.state;
    const rows = (snapshot && snapshot.rows) || [];
    const apiErrors = (snapshot && snapshot.errors) || [];
    return (
      <TradesSiteWrapper>
        <Page.Content
          title="Market Snapshot"
          subTitle="NIFTY / SENSEX spot and options — this page only."
          options={<RefreshButton onClick={this.load} loading={loading} />}
        >
          <Alert type="info">
            <span data-page-note="1">
              These are the NIFTY and SENSEX prices the strategies read. This page does not place orders.
            </span>
          </Alert>
          {error ? <Alert type="danger">{error}</Alert> : null}
          {!loading && apiErrors.length > 0 ? (
            <Alert type="warning">{apiErrors.join(" · ")}</Alert>
          ) : null}
          {loading ? <Text>Loading market…</Text> : null}
          {!loading && !error ? (
            <Card>
              <Card.Header>
                <Card.Title>
                  Updated {snapshot && snapshot.time_ist ? fmtDateTime(snapshot.time_ist) : "-"}
                </Card.Title>
              </Card.Header>
              {rows.map((r) => (
                <div className="border rounded mb-4" key={r.index_key}>
                  <div className="d-flex align-items-baseline px-3 py-3 border-bottom">
                    <strong style={{ fontSize: "1.1rem" }}>{r.index_key}</strong>
                    <span className="text-muted ml-3">Expiry {this.formatExpiry(r.expiry_date)}</span>
                  </div>
                  <div className="px-3 py-2 text-muted">
                    Spot {this.price(r.spot != null ? r.spot : r.spot_ltp)}
                    {" · "}
                    Day high {this.price(r.spot_day_high != null ? r.spot_day_high : r.day_high)}
                    {" · "}
                    Day low {this.price(r.spot_day_low != null ? r.spot_day_low : r.day_low)}
                  </div>
                  <div className="row px-3 pb-2">
                    {this.leg("ATM CE", r.ce_strike, r.ce_symbol, r.ce_ltp != null ? r.ce_ltp : r.atm_ce_ltp)}
                    {this.leg("ATM PE", r.pe_strike, r.pe_symbol, r.pe_ltp != null ? r.pe_ltp : r.atm_pe_ltp)}
                  </div>
                </div>
              ))}
            </Card>
          ) : null}
        </Page.Content>
      </TradesSiteWrapper>
    );
  }
}

export default MarketPage;
